import forEach from 'lodash/forEach';
import {LineNonNumericYChart, LineChartDataset, LineChart} from '../chart';
import minBy from 'lodash/minBy';
import maxBy from 'lodash/maxBy';

export const trendLine = {
  methods: {
    trendLine(item) {
      let SumOfPowX = 0, SumOfX = 0, n = item.length, SumOfXY = 0, SumOfY = 0;

      for (let i = 0; i < n; i++) {
        SumOfPowX += (i + 1) * (i + 1);
        SumOfX += (i + 1);
        SumOfXY += (i + 1) * item[i].y;
        SumOfY += item[i].y;
      }
      let det = SumOfPowX * n - Math.pow(SumOfX, 2);
      let a = (SumOfXY * n - SumOfX * SumOfY) / det;
      let b = (SumOfY - a * SumOfX) / n;

      let first = a + b;
      let last = a * n + b;

      let data = [
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[0].x,
          y: first,
        },
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[n - 1].x,
          y: last,
        },
      ];

      let dataset = new LineChartDataset({
        data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset

    },

    levelLine(item) {
      let n = item.length, SumOfY = 0, y = 0;

      forEach(item, point => {
        SumOfY += point.y;
      });

      y = SumOfY / n;

      let data = [
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[0].x,
          y: y,
        },
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[n - 1].x,
          y: y,
        },
      ];

      let dataset = new LineChartDataset({
        data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset

    },

    scatterLine(item) {
      let n = item.length, SumOfY = 0, y = 0;

      let min = minBy(item, function (o) {
        return o.y;
      });
      let max = maxBy(item, function (o) {
        return o.y;
      });


      let dataMin = [
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[0].x,
          y: min,
        },
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[n - 1].x,
          y: min,
        },
      ];

      let dataMax = [
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[0].x,
          y: max,
        },
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[n - 1].x,
          y: max,
        },
      ];

      let datasetMin = new LineChartDataset({
        data: dataMin,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      let datasetMax = new LineChartDataset({
        data: dataMax,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      let dataset = [datasetMin, datasetMax]

      return dataset

    },


    fetchDatasetLineTrend(item, trendLine, levelLine, scatterLine) {

      let data = [], trendPointIndex = [], trendPoint = [], i = 0;
      let array = [];

      forEach(item, (point, index) => {

        if (point.isImportant) {
          trendPoint.push(
              array
          );
          array = [];
          trendPointIndex.push(index)
        } else {
          if (!point.isChanged) {
            array.push(point);
          }
          if (index == item.length - 1) {
            trendPoint.push(
                array
            );
          }
        }

      });
      let dataset = [];

      if (trendLine) {
        forEach(trendPoint, (point) => {
          if (point.length > 2) {
            dataset.push(this.trendLine(point));
          }
        });
      }
      if (levelLine) {
        forEach(trendPoint, (point) => {
          if (point.length > 2) {
            dataset.push(this.levelLine(point));
          }
        });
      }
      if (scatterLine) {
        forEach(trendPoint, (point) => {
          if (point.length > 2) {
            dataset.push(this.scatterLine(point)[0]);
            dataset.push(this.scatterLine(point)[1]);
          }
        });
      }

      //this.isChangeStimuli = false;

      return dataset
    },

  },

  watch:{
    levelLineChecked(newValue) {
      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.dataset[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(() => {
        this.isChangeStimuli = false;
      }, 500);
    },
    trendLineChecked(newValue) {
      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.dataset[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(() => {
        this.isChangeStimuli = false;
      }, 500);

    },
    ScatterLineChecked(newValue) {
      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.dataset[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(() => {
        this.isChangeStimuli = false;
      }, 500);
    },
  }

}


// WEBPACK FOOTER //
// ./src/common/mixins/trendLine.js